import { gql } from '@apollo/client'

export const GET_ELD_APPS = gql`
  query GetELDApps($shipmentOwnerWorkspaceID: ID!, $carrierWorkspaceID: ID, $currentWorkspaceID: ID!) {
    getELDApps(
      input: {
        shipmentOwnerWorkspaceID: $shipmentOwnerWorkspaceID
        carrierWorkspaceID: $carrierWorkspaceID
        currentWorkspaceID: $currentWorkspaceID
      }
    ) {
      appType
      sourceWorkspaceType
      workspaceDisplayName
      workspaceID
    }
  }
`

export const GET_ELD_ASSET_LIST = gql`
  query GetELDAssetList($appType: String!, $assetType: AssetType!, $workspaceID: ID!) {
    getELDAssetList(input: { appType: $appType, assetType: $assetType, workspaceID: $workspaceID }) {
      assetID
      assetNumber
      assetType
    }
  }
`

export const GET_ELD_ASSET_LOCATION = gql`
  query GetELDAssetLocation(
    $appType: String!
    $assetID: String
    $assetNumber: String!
    $assetType: AssetType!
    $workspaceID: ID!
  ) {
    getELDAssetLocation(
      input: {
        appType: $appType
        assetID: $assetID
        assetNumber: $assetNumber
        assetType: $assetType
        workspaceID: $workspaceID
      }
    ) {
      address
      isoDateTime
      metadata
      sourceDisplayName
      sourceID
    }
  }
`

export interface IELDApp {
  appType: string
  sourceWorkspaceType: 'carrier' | 'shipmentOwner'
  workspaceDisplayName: string | null
  workspaceID: string
}

export interface IELDAsset {
  assetID: string
  assetNumber: string
  assetType: string
}

export interface IGetELDAppsResponse {
  getELDApps: IELDApp[]
}

export interface IGetELDAssetListResponse {
  getELDAssetList: IELDAsset[]
}

export interface IELDAssetLocation {
  address: unknown | null
  isoDateTime: string
  metadata: unknown | null
  sourceDisplayName: string
  sourceID: string
}

export interface IGetELDAssetLocationResponse {
  getELDAssetLocation: IELDAssetLocation | null
}
